export const common = {
  // Navigation
  nav_features: '기능',
  nav_security: '보안',
  nav_community: '커뮤니티',
  nav_join: '지금 가입',
  nav_back_home: '홈으로 돌아가기',
  
  // Hero Section
  hero_title: 'FaceTrue',
  hero_subtitle: '신원 확인 소셜 네트워크',
  hero_description_1: '가짜 계정 없음. 괴롭힘 없음. 폭력 없음.',
  hero_description_2: '유해성 없음. 극단주의 없음.',
  hero_description_3: '100% 긍정적 - AI 검증됨.',
  
  // How It Works
  how_title: '작동 방식',
  step1_title: '얼굴 인증',
  step1_desc: '셀카 촬영 → AI 신원 확인 → 즉시 검증',
  step1_badge: '가짜 계정 없음',
  step2_title: '깨끗한 콘텐츠',
  step2_desc: 'AI가 유해, 사기, 폭력적 콘텐츠를 24시간 필터링',
  step2_badge: 'AI 필터 24/7',
  step3_title: '글로벌 커뮤니티',
  step3_desc: '국내 또는 전 세계에 게시',
  step3_badge: '세계 각국',
  
  // Age-Based Content
  age_title: '연령별 콘텐츠',
  children_label: '어린이',
  children_title: '어린이용',
  children_feature1: '안전한 교육 콘텐츠',
  children_feature2: '친근한 환경',
  children_feature3: '부모 감독',
  adults_label: '성인',
  adults_title: '성인용',
  adults_feature1: '사회적 토론',
  adults_feature2: '경력 및 라이프스타일',
  adults_feature3: '글로벌 연결',
  seniors_label: '노인',
  seniors_title: '노인용',
  seniors_feature1: '건강 정보',
  seniors_feature2: '경험 공유',
  seniors_feature3: '지원 커뮤니티',
  
  // Why Different
  why_title: 'FaceTrue를 선택하는 이유',
  why_feature1_title: '100% 실제 사람',
  why_feature1_desc: 'AI 신원 확인, 가짜 계정 제거',
  why_feature2_title: '폭력 및 유해성 없음',
  why_feature2_desc: 'AI가 폭력적, 유해, 괴롭힘 콘텐츠를 24시간 필터링',
  why_feature3_title: '극단주의 없음',
  why_feature3_desc: '모든 형태의 극단주의와 증오 제거',
  why_feature4_title: '100% 긍정적',
  why_feature4_desc: '긍정적이고 건설적이며 건강한 콘텐츠만',
  why_feature5_title: '모든 연령대에 안전',
  why_feature5_desc: '스마트 콘텐츠 분류, 각 연령대에 적합',
  why_feature6_title: '3단계 경고 시스템',
  why_feature6_desc: '노란 깃발 (1차 위반) → 빨간 깃발 (2차 위반) → 검은 깃발 (3차 위반 - 계정 잠금)',
  why_feature7_title: '별점 평가 시스템',
  why_feature7_desc: '긍정적인 정보, 이미지, 비디오 공유 → 커뮤니티로부터 분홍색 하트 별 받기',
  why_feature8_title: '진짜 광고',
  why_feature8_desc: 'AI가 광고 진위 확인. 제품은 게시 전 출처 확인',
  
  // Video Demo
  video_title: 'FaceTrue 데모 비디오',
  video_subtitle: '작동 방식 보기',
  video_views: '조회수',
  video_close: 'X를 클릭하여 닫기',
  video_demo_live: '데모 라이브',
  video_info: 'FaceTrue 시뮬레이션 데모',
  video_info_cta: '재생을 클릭하여 데모 보기',
  video_update: '실제 비디오는 Veo AI에서 업데이트됩니다',
  
  // Video Stages
  scanning_title: '확인 중...',
  scanning_desc: 'AI가 신원 확인 중',
  scanning_step1: '얼굴 감지됨',
  scanning_step2: 'AI 검증',
  scanning_step3: '프로필 생성 중...',
  scanning_badge: '100% 실제 사람',
  
  intro_step1_title: '검증 성공',
  intro_step1_subtitle: '100% 실제 사람',
  intro_step2_title: 'AI 콘텐츠 필터링',
  intro_step2_subtitle: '유해성 없음, 폭력 없음',
  intro_step3_title: '글로벌 연결',
  intro_step3_subtitle: '119개국',
  intro_step4_title: '100% 긍정적',
  intro_step4_subtitle: '건강한 콘텐츠만',
  intro_step5_title: '모든 연령대에 안전',
  intro_step5_subtitle: '어린이 • 성인 • 노인',
  
  stats_title: 'FaceTrue 커뮤니티',
  stats_subtitle: '강력하게 성장 중',
  stats_users: '사용자',
  stats_countries: '국가',
  stats_posts: '긍정적인 게시물',
  stats_badge: '100% 긍정적',
  
  comparison_title: '차이점',
  comparison_old: '기존 소셜 미디어',
  comparison_old_1: '가짜 계정',
  comparison_old_2: '유해한 콘텐츠',
  comparison_old_3: '폭력',
  comparison_old_4: '사기',
  comparison_new: 'FaceTrue',
  comparison_new_1: '100% 실제 사람',
  comparison_new_2: '깨끗한 콘텐츠',
  comparison_new_3: '100% 긍정적',
  comparison_new_4: 'AI 안전',
  
  // CTA Section
  cta_title: '지금 가입',
  cta_subtitle: 'FaceTrue 베타 버전 가입',
  cta_name: '전체 이름',
  cta_email: '이메일',
  cta_button: '지금 가입',
  cta_submitting: '제출 중...',
  cta_success: '🎉 감사합니다! 곧 연락드리겠습니다.',
  cta_error: '❌ 오류가 발생했습니다. 다시 시도해주세요.',
  cta_privacy: '귀하의 개인정보를 존중합니다',
  
  // Footer
  footer_copyright: '© 2025 FaceTrue 글로벌 소셜 네트워크',
  footer_creator: 'Ben Nguyen이 제작',
  footer_powered: '웹사이트 빌더',
  
  // Time
  time_hours_ago: '시간 전',
  time_day_ago: '일 전',
  
  // Children Page
  children_nav_features: '특징',
  children_nav_safety: '안전',
  children_nav_activities: '활동',
  children_back_home: '홈으로 돌아가기',
  
  children_hero_title: '환영합니다',
  children_hero_subtitle: '작은 천사들',
  children_hero_desc: '어린이를 위해 특별히 설계된 안전하고 재미있으며 교육적인 공간!<br />AI 보호 기능이 있는 100% 부모 승인 콘텐츠.',
  children_explore_btn: '기능 탐색',
  children_safety_btn: '안전 우선',
  
  children_features_title: '재미있고 교육적인 기능',
  children_features_subtitle: '어린이가 안전하게 배우고, 놀고, 성장하는 데 필요한 모든 것',
  
  children_feature1_title: '교육 콘텐츠',
  children_feature1_desc: '연령에 맞는 학습 자료, 재미있는 퀴즈 및 교육을 재미있게 만드는 대화형 수업.',
  
  children_feature2_title: '안전한 게임',
  children_feature2_desc: '재미있고 교육적이며 어린이에게 완전히 안전한 신중하게 선별된 게임.',
  
  children_feature3_title: '창의적인 활동',
  children_feature3_desc: '그림 그리기, 색칠하기, 이야기 만들기 및 상상력을 자극하는 기타 창의적인 활동.',
  
  children_safety_title: '자녀의 안전이 최우선입니다',
  children_safety_subtitle: '걱정 없는 경험을 보장하는 여러 보호 계층',
  
  children_safety1_title: 'AI 콘텐츠 필터링',
  children_safety1_desc: '24시간 AI 모니터링으로 적절한 콘텐츠만 어린이에게 도달하도록 보장합니다.',
  
  children_safety2_title: '부모 통제',
  children_safety2_desc: '부모는 활동을 모니터링하고 건강한 화면 시간 제한을 설정할 수 있습니다.',
  
  children_safety3_title: '낯선 사람 없음',
  children_safety3_desc: '어린이는 확인된 친구 및 가족 구성원과만 상호 작용할 수 있습니다.',
  
  children_activities_title: '재미있는 활동 탐색',
  children_activities_subtitle: '활동을 클릭하여 자세히 알아보고 놀기 시작하세요!',
  
  // 8 Activities
  activity1_title: '그림 & 미술',
  activity1_desc: '디지털 도구로 멋진 예술 작품 만들기',
  
  activity2_title: '교육 게임',
  activity2_desc: '대화형 게임으로 재미있게 배우기',
  
  activity3_title: '이야기 & 독서',
  activity3_desc: '이야기를 통해 마법의 세계 탐험',
  
  activity4_title: '음악 & 노래',
  activity4_desc: '재미있는 노래와 멜로디 발견',
  
  activity5_title: '사진 & 비디오',
  activity5_desc: '특별한 순간 포착 및 공유',
  
  activity6_title: '그룹 활동',
  activity6_desc: '친구들과 함께 놀고 배우기',
  
  activity7_title: '도전 & 보상',
  activity7_desc: '재미있는 도전 완료 및 보상 획득',
  
  activity8_title: '특별 이벤트',
  activity8_desc: '흥미진진한 계절 활동 참여',
  
  children_footer_copyright: '© 2025 FaceTrue 어린이 구역',
  children_footer_desc: '어린이가 배우고 놀 수 있는 안전한 공간',
  
  children_modal_safe_badge: '안전하고 재미있음',
  children_modal_what_you_can_do: '할 수 있는 것',
  children_modal_start_btn: '활동 시작',
  
  children_modal_close: '닫기',
  children_modal_start: '시작',
  
  // Adults Page
  adults_nav_features: '기능',
  adults_nav_community: '커뮤니티',
  adults_nav_benefits: '혜택',
  adults_back_home: '홈으로 돌아가기',
  adults_hero_title: '연결하기',
  adults_hero_subtitle: '진짜 사람들, 진짜 이야기',
  adults_hero_desc: '진정한 경험을 공유하고,<br />의미 있는 연결을 구축하며, 함께 성장하는 검증된 성인 커뮤니티에 가입하세요.',
  adults_explore_btn: '기능 탐색',
  adults_join_btn: '커뮤니티 가입',
  adults_features_title: '연결에 필요한 모든 것',
  adults_features_subtitle: '전문 네트워킹, 라이프스타일 공유, 의미 있는 대화',
  adults_feature1_title: '경력 및 전문가',
  adults_feature1_desc: '전문가와 네트워크를 구축하고, 경력 통찰력을 공유하며, 귀하의 분야에서 기회를 발견하세요.',
  adults_feature2_title: '라이프스타일 및 관심사',
  adults_feature2_desc: '전 세계의 같은 생각을 가진 사람들과 열정, 취미, 일상 생활을 공유하세요.',
  adults_feature3_title: '깊은 대화',
  adults_feature3_desc: '검증된 사용자와 귀하에게 중요한 주제에 대해 의미 있는 토론에 참여하세요.',
  adults_community_title: '글로벌 커뮤니티 가입',
  adults_community_subtitle: '귀하의 관심사와 가치를 공유하는 사람들과 연결',
  adults_community_entrepreneurs: '기업가',
  adults_community_entrepreneurs_desc: '비즈니스 아이디어 및 스타트업 토론',
  adults_community_health: '건강 및 웰니스',
  adults_community_health_desc: '피트니스, 영양 및 정신 건강',
  adults_community_arts: '예술 및 문화',
  adults_community_arts_desc: '창의적 표현 및 문화 교류',
  adults_community_travel: '여행 및 모험',
  adults_community_travel_desc: '경험 및 여행 팁 공유',
  adults_community_food: '음식 및 요리',
  adults_community_food_desc: '레시피, 레스토랑 및 요리 예술',
  adults_community_technology: '기술',
  adults_community_technology_desc: '기술 트렌드 및 혁신',
  adults_community_parenting: '육아',
  adults_community_parenting_desc: '가족 생활 및 육아 팁',
  adults_community_education: '교육',
  adults_community_education_desc: '학습 및 개인 개발',
  adults_community_active: '활성 커뮤니티',
  adults_community_join_btn: '커뮤니티 가입',
  adults_benefits_title: '성인이 FaceTrue를 선택하는 이유',
  adults_benefits_subtitle: '진정한 성인 연결을 위해 구축된 소셜 네트워크',
  adults_benefit1_title: '검증된 신원',
  adults_benefit1_desc: '모두가 본인임을 알고 자신 있게 연결하세요.',
  adults_benefit2_title: '독성 없음',
  adults_benefit2_desc: 'AI 필터링이 괴롭힘, 혐오 발언 및 부정적인 콘텐츠를 제거합니다.',
  adults_benefit3_title: '글로벌 도달',
  adults_benefit3_desc: '전 세계 119개국의 검증된 사용자와 연결하세요.',
  adults_benefit4_title: '개인정보 우선',
  adults_benefit4_desc: '귀하의 데이터는 기업급 보안 조치로 보호됩니다.',
  adults_footer_copyright: '© 2025 FaceTrue 성인 커뮤니티',
  adults_footer_desc: '전 세계 검증된 성인과 진정으로 연결',
  
  // Seniors Page
  seniors_nav_features: '기능',
  seniors_nav_health: '건강',
  seniors_nav_community: '커뮤니티',
  seniors_back_home: '홈으로 돌아가기',
  seniors_hero_title: '커뮤니티',
  seniors_hero_subtitle: '노인을 위해 구축',
  seniors_hero_desc: '지혜를 공유하고, 사랑하는 사람들과 연결을 유지하며,<br />안전하고 지원적인 온라인 커뮤니티를 즐기세요.',
  seniors_explore_btn: '기능 탐색',
  seniors_safety_btn: '커뮤니티 가입',
  seniors_features_title: 'FaceTrue에서 할 수 있는 것',
  seniors_features_subtitle: '연결하고, 공유하고, 의미 있는 상호 작용을 즐기세요',
  seniors_feature1_title: '가족 연결',
  seniors_feature1_desc: '전 세계 가족 구성원과 연결을 유지하세요. 안전한 환경에서 사진, 비디오 및 생활 업데이트를 공유하세요.',
  seniors_feature2_title: '이야기 공유',
  seniors_feature2_desc: '인생 경험, 지혜, 추억을 다른 사람들과 공유하세요. 귀하의 이야기는 중요하고 영감을 줍니다.',
  seniors_feature3_title: '새로운 친구 사귀기',
  seniors_feature3_desc: '관심사와 취미를 공유하는 사람들과 연결하세요. 의미 있는 우정을 쌓으세요.',
  seniors_feature4_title: '지역 이벤트',
  seniors_feature4_desc: '근처의 지역 커뮤니티 이벤트, 활동 및 모임을 발견하고 참여하세요.',
  seniors_feature5_title: '새로운 기술 배우기',
  seniors_feature5_desc: '기술, 취미 및 일상 생활 기술에 대한 튜토리얼, 팁 및 안내에 액세스하세요.',
  seniors_feature6_title: '지원 그룹',
  seniors_feature6_desc: '건강, 웰니스 및 삶의 도전을 위한 지원 커뮤니티에 가입하세요. 혼자가 아닙니다.',
  seniors_health_title: '건강 및 웰니스 리소스',
  seniors_health_subtitle: '신뢰할 수 있는 정보로 정보를 얻고 건강을 유지하세요',
  seniors_health1_title: '건강 팁',
  seniors_health1_desc: '노인을 위해 맞춤화된 일일 건강 조언, 영양 팁 및 운동 안내.',
  seniors_health2_title: '정신 건강',
  seniors_health2_desc: '정신 건강 지원, 마음챙김 실천 및 스트레스 관리.',
  seniors_health3_title: '약물 알림',
  seniors_health3_desc: '약물 및 건강 약속에 대한 알림을 설정하여 계속 진행하세요.',
  seniors_health4_title: '활동 추적',
  seniors_health4_desc: '일일 활동, 걸음 수를 추적하고 웰니스 이정표를 축하하세요.',
  seniors_community_title: '커뮤니티와 연결',
  seniors_community_subtitle: '지원을 찾고, 경험을 공유하고, 의미 있는 연결을 만드세요',
  seniors_community_family: '가족 연결',
  seniors_community_family_desc: '가족과 가까이',
  seniors_community_stories: '이야기 공유',
  seniors_community_stories_desc: '인생 경험 및 지혜',
  seniors_community_friends: '새로운 친구 사귀기',
  seniors_community_friends_desc: '전 세계 동료와 연결',
  seniors_community_events: '지역 이벤트',
  seniors_community_events_desc: '커뮤니티 활동 및 모임',
  seniors_community_learning: '새로운 기술 배우기',
  seniors_community_learning_desc: '성장과 학습을 멈추지 마세요',
  seniors_community_support: '지원 그룹',
  seniors_community_support_desc: '이해와 격려 찾기',
  seniors_community_join_btn: '커뮤니티 가입',
  seniors_benefits_title: '노인이 FaceTrue를 사랑하는 이유',
  seniors_benefits_subtitle: '귀하의 경험을 존중하고 가치 있게 여기는 소셜 네트워크',
  seniors_benefit1_title: '사기 또는 사기 없음',
  seniors_benefit1_desc: '사기꾼 및 사기 활동에 대한 AI 보호.',
  seniors_benefit2_title: '크고 명확한 텍스트',
  seniors_benefit2_desc: '편안한 보기를 위해 설계된 읽기 쉬운 인터페이스.',
  seniors_benefit3_title: '24/7 지원',
  seniors_benefit3_desc: '도움이 필요할 때 항상 도움을 받을 수 있습니다.',
  seniors_benefit4_title: '개인정보 보호',
  seniors_benefit4_desc: '귀하의 개인 정보는 항상 안전하고 비공개로 유지됩니다.',
  seniors_benefit5_title: '존중하는 커뮤니티',
  seniors_benefit5_desc: '모두가 서로를 존중하는 긍정적인 환경.',
  seniors_benefit6_title: '무료 사용',
  seniors_benefit6_desc: '모든 기능을 무료로 사용할 수 있습니다.',
  seniors_footer_copyright: '© 2025 FaceTrue 노인 커뮤니티',
  seniors_footer_desc: '노인이 연결할 수 있는 안전하고 지원적인 공간',
};

export default common;
